module.exports = __webpack_public_path__ + "img/video2.fb8b7631.jpg";